<script lang="ts">
    import {documentTags} from "$lib/utils/documentTag";
    import {Button, Label, Modal, Select, Spinner} from "flowbite-svelte";
    import {onMount} from "svelte";
    import {deleteEmployeeImage} from "$lib/calls/employee";
    import {updateDocumentTag} from "$lib/calls/document";
    import {globalConfirm} from "$lib/stores/modal";
    import ModalHeader from "$lib/components/ui/ModalHeader.svelte";
    import ModalFooter from "$lib/components/ui/ModalFooter.svelte";
    import {
        DownloadOutline, PenOutline, TrashBinOutline
    } from "flowbite-svelte-icons";
    import convertPdfToImage from "$lib/utils/convertPdfToImage";


    export let value;

    export let employee
    export let findDocument = () => {
    }
    export let callback = () => {
    }

    export let classes = 'text-center'

    let openPreview = false
    let openChange = false
    const handleButtonClick = () => {
        previews = [];
        try {
            render();
        } catch (e) {
            console.log(e);
        }

        if (!currentDocument.templateDocumentId) {
            openChange = true;
        } else {
            openPreview = true;
        }
    };


    let currentDocument = null
    onMount(() => {
        currentDocument = findDocument(value);
        console.log(value)
    })

    const deleteDocument = async () => {
        await deleteEmployeeImage(employee.uuid, currentDocument)
        openChange = false;
        callback(currentDocument, "removed")
    }

    const updateDocument = async () => {
        await updateDocumentTag(
            currentDocument,
            employee.uuid,
            currentDocument.imageTag
        );
        openChange = false;
        callback(currentDocument, "updated")
    }

    let previews: string[] = [];
    const render = async () => {
        try {
            if (currentDocument.location.includes('sign.celest.services')) {
                currentDocument.location += '?direct-download=true'
            }
            const converted = await convertPdfToImage(currentDocument.location);
            converted.forEach((preview) => {
                previews = [...previews, preview]
            })
        } catch (e) {
            console.error(e)
        }
    }

</script>

{#if currentDocument}

    {#if currentDocument.templateDocumentId && currentDocument.location.split('.')[currentDocument.location.split('.').length - 1] !== 'pdf'}
        <div class="{classes}">
            <Button href="{currentDocument.location}" type="button"
                    class="!p-1.5 rounded-full bg-primary-600 p-1 text-white shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600">
                <DownloadOutline class="h-4 w-4"/>
            </Button>
        </div>
    {:else}
        <div class="{classes}">
            <Button on:click={handleButtonClick} type="button"
                    class="!p-1.5 rounded-full bg-primary-600 p-1 text-white shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600">
                <PenOutline class="w-4 h-4"/>
            </Button>
        </div>
    {/if}


    <Modal title="Aktionen" bind:open={openChange}>
        <svelte:fragment slot="header">
            <ModalHeader>{currentDocument.name}</ModalHeader>
        </svelte:fragment>
        <Label class="text-neutral-600 mb-3" tag="h5">{currentDocument.name}</Label>
        <div class="flex justify-between gap-4">
            <Select bind:value={currentDocument.imageTag}
                    items={documentTags.filter(x => !['contract-document', 'avatar'].includes(x.value))}/>
            <Button on:click={updateDocument}>
                Übernehmen
            </Button>
        </div>
        {#if previews.length > 0}
            {#each previews as preview,i}
                <div class="text-center mb-3">Seite {i + 1}</div>
                <img src={preview} alt="Seite-{i+1}">
            {/each}
        {:else}
            <img src={currentDocument.location} alt="">
        {/if}

        <svelte:fragment slot="footer">
            <ModalFooter on:abort={() => openChange = false}>
                <div slot="left">
                    <Button color="red"
                            on:click={() =>{openChange = false; $globalConfirm.confirm('Sicher?', deleteDocument)}}
                            target="_blank">
                        <TrashBinOutline class="w-5 h-5"/>
                    </Button>
                </div>
                <div slot="right">
                    <Button on:click={() => openChange = true} id="download" href={currentDocument.location}
                            target="_blank">
                        <DownloadOutline></DownloadOutline>
                        Download
                    </Button>
                </div>
            </ModalFooter>
        </svelte:fragment>
    </Modal>

    <Modal size="lg" bind:open={openPreview}>
        <svelte:fragment slot="header">
            <ModalHeader title="Dokument"/>
        </svelte:fragment>
        {#if previews.length > 0}
            {#each previews as preview,i}
                <div class="text-center mb-3">Seite {i + 1}</div>
                <img src={preview} alt="Seite-{i+1}">
            {/each}
        {:else}
            <Spinner/>
        {/if}
        <svelte:fragment slot="footer">
            <ModalFooter nextText="Download" on:next={() => window.open(currentDocument.location, '_blank')}/>
        </svelte:fragment>
    </Modal>
{/if}